/** Ab so vielen Einträgen wird eine Aufzählung eingeklappt. */
export const COLLAPSE_LIST_THRESHOLD = 8;

/** So viele Einträge bleiben sichtbar. */
export const COLLAPSE_LIST_VISIBLE = 5;

const MARKER = 'chatListCollapsed';

/**
 * Klappt lange Aufzählungen in einer gerenderten Chat-Antwort ein.
 *
 * <p>Die Antwort ist Markdown, das ngx-markdown als fertiges HTML einsetzt – eine Angular-Komponente
 * je Liste gibt es nicht. Deshalb wird nach dem Rendern am DOM gearbeitet: die Einträge nach dem
 * {@link COLLAPSE_LIST_VISIBLE}. wandern in eine zweite Liste gleichen Typs in einem nativen
 * `<details>`. Das klappt ohne eigenen Zustand und ohne Event-Handler, die beim nächsten Rendern
 * verwaist wären; nummerierte Listen zählen über `start` korrekt weiter.
 *
 * <p>Idempotent: ngx-markdown rendert bei jeder Änderung der Daten neu, eine bereits behandelte
 * Liste wird erkannt und übersprungen.
 */
export function collapseLongLists(root: HTMLElement | null | undefined,
                                  threshold = COLLAPSE_LIST_THRESHOLD,
                                  visible = COLLAPSE_LIST_VISIBLE): void {
  if (!root) return;
  const lists = Array.from(root.querySelectorAll<HTMLUListElement | HTMLOListElement>('ul, ol'));
  for (const list of lists) {
    if (list.dataset[MARKER] || list.closest('details.chat-list-more')) continue;
    const items = Array.from(list.children).filter(child => child.tagName === 'LI');
    if (items.length <= threshold) continue;

    list.dataset[MARKER] = 'true';
    const hidden = items.slice(visible);

    const rest = document.createElement(list.tagName.toLowerCase()) as HTMLUListElement | HTMLOListElement;
    rest.dataset[MARKER] = 'true';
    if (list instanceof HTMLOListElement) {
      (rest as HTMLOListElement).start = (list.start || 1) + visible;
    }
    hidden.forEach(item => rest.appendChild(item));

    const details = document.createElement('details');
    details.className = 'chat-list-more';
    const summary = document.createElement('summary');
    const label = (open: boolean) => open ? 'Weniger anzeigen' : `Weitere ${hidden.length} anzeigen`;
    summary.textContent = label(false);
    details.addEventListener('toggle', () => summary.textContent = label(details.open));
    details.append(summary, rest);

    list.insertAdjacentElement('afterend', details);
  }
}
